<script lang="ts">
  import clsx from 'clsx'
  import { fade } from 'svelte/transition'
  import chaptersStore, { type Cue } from '../../stores/chapters.svelte'
  import componentAttributes from '../../stores/componentAttributes.svelte'
  import videoStore from '../../stores/video.svelte'
  import CaptionsButton from './buttons/CaptionsButton.svelte'
  import SettingsButton from './buttons/SettingsButton.svelte'
  import { THEMES } from '../../const/themes'

  let currentChapter: Cue | undefined = $state(undefined)

  $effect(() => {
    if (!!chaptersStore.state.cues) {
      currentChapter = undefined
      chaptersStore.state.cues.forEach((cue: Cue) => {
        if (
          cue.start <= videoStore.state.currentTime &&
          cue.end >= videoStore.state.currentTime
        ) {
          currentChapter = cue
        }
      })
    }
  })
</script>

{#if (videoStore.showControls() || !videoStore.state.isPlaying) && ((!componentAttributes.state.hideTitle && (componentAttributes.state.mediaTitle || currentChapter)) || videoStore.state.isMobileLayout)}
  <div
    class={clsx(
      'bg-overlayGradientTopToBottom h-full absolute top-0 left-0 w-full',
      {
        'z-10': !videoStore.state.settingsMenuOpen,
      },
    )}
    transition:fade={{ duration: 100 }}
  >
    <div class="flex justify-between">
      <div
        class="font-bold px-3 pt-2 drop-shadow-[0px_0px_1px_#000000_40] z-40"
        style={`color: ${componentAttributes.state.titleColor || THEMES.DEFAULT.TITLE_COLOR}`}
      >
        {#if !componentAttributes.state.hideTitle && (componentAttributes.state.mediaTitle || currentChapter)}
          <p>
            {componentAttributes.state.mediaTitle}
            {#if currentChapter}
              <span class="text-sm opacity-80">
                {currentChapter.text}
              </span>
            {/if}
          </p>
        {/if}
      </div>
      {#if videoStore.state.isMobileLayout}
        <div class="gap-4 flex justify-end px-3 mt-2 h-7 z-40 relative">
          <SettingsButton />
          <CaptionsButton />
        </div>
      {/if}
    </div>
  </div>
{/if}
